import React from 'react'
import styled from 'styled-components'

const AboutContainer = styled.div`
  padding-left: 20px;
  padding-right: 20px;
`

export const About = () => (
  <AboutContainer>
    <h2>JavaScript recruitment assessment</h2>
    <p>
      When recruiting new developers it’s always tricky to know how good of a
      developer a person is. As a recruiter you wouldn’t hire anyone you don’t
      know is good, and frankly as a developer you probably wouldn’t want to be
      hired by someone that doesn't know how good you are. I mean, how would you
      get the salary you deserve?
    </p>
    <p>
      So an assessment of some form is required, and this is it. It’s probably
      not the first one you’ve done so I’ve tried to do it as fun as possible,
      see it as a hobby project you actually can use when you’re done.
    </p>
    <p>
      So here at LeoVegas we like React. Like, a lot. We hope you do too. So
      let’s start by creating a git repository and a new React project, and
      don’t forget to give it a cool name. There’s something I like more than
      React though it is movies. Especially good movies. But also bad movies. So
      what we’re gonna build today is an application for searching for just
      that, movies. The app must look good in desktop as well as mobile.
    </p>
    <p>
      Feature wise we’ll need:
      <ul>
        <li>A search field and like a table for showing the result.</li>
        <li>
          It should also have functionality for setting movies as your
          favourites, maybe with a star symbol in the table.
        </li>
        <li>
          A list where you can add movies you want to watch, like the “watch
          later” functionality on YouTube.
        </li>
        <li>
          Make Sure to test the application and write the tests in the Repo.
        </li>
        <li>The App Must Be working on desktop as well as mobile.</li>
        <li>
          Posters and trailers are always nice, this is however up to
          you.(Optional)
        </li>
        <li>
          Last but definitely NOT least, please include a Demo for us to see.
        </li>
      </ul>
    </p>
    <p>
      To get the data for movies you can use any API you want, but if I were
      you, I'd use the API provided by TMDb:{' '}
      <a href="https://www.themoviedb.org/documentation/api">
        https://www.themoviedb.org/documentation/api
      </a>{' '}
      When you’re done, send us the repo and sit back, relax, and be proud of
      your work. No doubt we’ll hire you after a performance like this.
    </p>
  </AboutContainer>
)
